export enum AppBlock {
  Root = 'App',
}

export enum AppElement {
  Header = 'header',
}
